import "./SubmitActionNotices.less";
import { useStrings } from "features/i18n/useStrings";
import strings from "./SubmitActionNotices.strings";
import { GuxInlineAlert } from "genesys-spark-components-react";

export function SubmitActionNotices({
    isAdmin,
    submitNotices,
}: {
    isAdmin: boolean;
    submitNotices: string[];
}) {
    const t = useStrings(strings);

    return (
        <div
            className={`SubmitActionNotices ${
                isAdmin ? "AdminNotice" : "AgentNotice"
            }`}
        >
            {submitNotices.map((notice) => (
                <GuxInlineAlert
                    accent="warning"
                    key={notice}
                    className={isAdmin ? "notice" : "notice nomargin"}
                >
                    {t.messages[notice]}
                </GuxInlineAlert>
            ))}
        </div>
    );
}
